import {ITEM_TYPE} from '../constants'

// Flatten a rule's `when` (an {all|any} group, with at most one nested group
// level) into its leaf conditions.
const leafConditions = group => {
  const conditions = group?.all || group?.any || []
  return conditions.flatMap(c => (c?.all || c?.any ? leafConditions(c) : [c]))
}

// Rules (and "otherwise" routes) in other skip-logic sections that send
// respondents to, or test, the given item. Used to warn before deleting or
// moving an item a rule depends on. Items are matched by their integer itemId.
export const findReferences = (survey, itemId) =>
  (survey?.items || [])
    .filter(
      item => item?.itemType === ITEM_TYPE.SKIP_LOGIC && item.itemId !== itemId
    )
    .flatMap(section => {
      const references = []
      ;(section.rules?.rules || []).forEach((rule, i) => {
        const asCondition = leafConditions(rule.when).some(
          c => c?.answer?.item === itemId
        )
        const asDestination = rule.goTo?.item === itemId
        if (asCondition || asDestination) {
          references.push({
            sectionKey: section.itemId,
            ruleId: rule.id,
            ruleNumber: i + 1,
            asCondition,
            asDestination,
          })
        }
      })
      const otherwise = section.rules?.otherwise
      if (otherwise?.item === itemId) {
        references.push({
          sectionKey: section.itemId,
          ruleId: null,
          ruleNumber: null,
          asCondition: false,
          asDestination: true,
        })
      }
      return references
    })
